import xhr from './xhr'

// Environment variables
const API_BASE = process.env.VUE_APP_API_BASE
const API_REFDATA = process.env.VUE_APP_API_REFDATA
const CLEINTID_APPLY = process.env.VUE_APP_CLEINTID_APPLY

export default {
  getCounties() {
    return xhr.get(`${API_REFDATA}/county.json`)
  },
  getAuthCognitoSession(userId, recaptchaToken) {
    return xhr.post(`${CLEINTID_APPLY}/passwordless/initiateAuth`, {
      userId: userId,
      recaptchaToken
    })
  },
  getAuthRefreshToken(userId, refreshToken) {
    return xhr.post(`${CLEINTID_APPLY}/passwordless/refreshToken`, {
      userId,
      refreshToken
    })
  },
  postAuthOTP(userId, cognitoSession, otpCode) {
    return xhr.post(`${CLEINTID_APPLY}/passwordless/authenticate`, {
      userId: userId,
      cognitoSession: cognitoSession,
      code: otpCode
    })
  },
  getFormData(auth) {
    return xhr.get(`${API_BASE}/applications/self`, {
      headers: {
        Pragma: 'no-cache',
        Authorization: `Bearer ${auth}`
      }
    })
  },
  createApplication(idToken, application) {
    return xhr.put(
      `${API_BASE}/applications/self`,
      { application, isNew: true },
      {
        headers: {
          Pragma: 'no-cache',
          Authorization: `Bearer ${idToken}`
        }
      }
    )
  },
  saveApplication(auth, payload) {
    return xhr.put(
      `${API_BASE}/applications/self`,
      { application: payload },
      {
        headers: {
          Pragma: 'no-cache',
          Authorization: `Bearer ${auth}`
        }
      }
    )
  },
  submitApplication(auth, payload, userConfig) {
    let data = { application: payload }

    if (userConfig) {
      data.userConfig = userConfig
    }

    return xhr.post(`${API_BASE}/applications/self`, data, {
      headers: {
        Pragma: 'no-cache',
        Authorization: `Bearer ${auth}`
      }
    })
  },

  cancelApplication(auth) {
    return xhr.delete(`${API_BASE}/applications/self`, {
      headers: {
        Pragma: 'no-cache',
        Authorization: `Bearer ${auth}`
      }
    })
  },  
  
  // Reference Data API
  getReferenceData() {
    return xhr.get(`${API_REFDATA}/pi-reference-data.json`)
  },
  getOESProperties() {
    return xhr.get(`${API_REFDATA}/oes-properties.json`)
  }, 
  generateSignedURL(authToken, file, category, action) {
    return xhr.post(
      `${API_BASE}/application/self/uploads/generateSignedUrl`,
      { filename: file.name, filetype: file.type, category, action },
      {
        headers: {
          Pragma: 'no-cache',
          Authorization: `Bearer ${authToken}`
        }
      }
    )
  },
  uploadFile(url, file, progressCallback) {
    const config = {
      onUploadProgress: progressCallback,
      headers: {
        'Content-Type': file.type
      }
    }
    return xhr.put(url, file, config)
  },
  deleteFile(url) {
    return xhr.delete(url)
  },  
  
}
